module.exports = __webpack_public_path__ + "static/media/delete-icon.4d0081db.svg";